<template>
  <div>
    <div v-if="delivery===false" style="text-align:center;color:lightgray;padding-top:20px;padding-bottom:0px">
      <h6 style="padding:0px">Motor Insurance Quote</h6>
    </div>
    <div v-else>
      <div style="text-align:center;color:white;padding-top:20px;">
        <h6>Delivery Information</h6>
      </div>
      <div style="text-align:center;color:lightgray;font-size:12px">
        <p style="padding:0px;margin:0px;color:gray">Lusaka based Clients can select a Zone below and have the Policy Documents delivered at a Fee</p>
        <p style="padding:0px;margin:0px;color:gray">(Clients in other Towns can collect Policy Documents at nearest PICZ Branch at No Fee)</p>
      </div>
    </div>
    <div v-if="delivery===false">
      <v-stepper
        v-model="e1"  
        style="background-color:transparent;padding-top:0px;padding-bottom:0px" 
        dark
      >
        <v-stepper-header style="font-size:12px;padding-bottom:0px;padding-top:0px;color:lightgray">
          <v-stepper-step :complete="e1 > 1" step="1">Client Details</v-stepper-step>
          <v-divider></v-divider>          
          <v-stepper-step :complete="e1 > 2" step="2">Vehicle Details</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="3">Quotation Details</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content dark step="1" style="height:380px">
            <div style="height:280px;font-size:14px;color:lightgray">            
            <v-form ref="form1">
              <v-row class="ma-0 pa-0"
              >
                <v-col
                  style="padding:0px"
                  cols="12"
                  sm="6"
                >                   
                  <v-text-field v-if="user.loggedIn"
  
                    placeholder="First name *"        
                    filled              
                    v-model="user.data.first_name"                     
                    required
                    :rules="[v => !!v || 'This is a required field']"
                    height="10px"
                    color="blue"
                    outlined
                    background-color="rgb(66,66,66,0.85)"
                    dense            
                    style="color:lightgray;padding-right:5px;font-size:12px;"
                  >  
                  </v-text-field>
                  <v-text-field v-else
                  
                    placeholder="First name *"                        
                    v-model="custom.first_name"                     
                    required
                    :rules="[v => !!v || 'This is a required field']"
                    outlined
                    color="blue"
                    background-color="rgb(66,66,66,0.85)"
                    dense            
                    style="color:lightgray;padding-right:5px;font-size:12px"
                  >  
                  </v-text-field>
                </v-col>
                <v-col 
                  style="padding:0px;"
                  cols="12"
                  sm="6"
                > 
                  <v-text-field v-if="user.loggedIn"
                
                    placeholder="Last name *"
                    v-model="user.data.last_name"                      
                    required
                    :rules="[v => !!v || 'This is a required field']"
                    outlined
                    background-color="rgb(66,66,66,0.85)"
                    dense                       
                    style="padding-left:5px;color:lightgray;font-size:12px"
                  >  
                  </v-text-field>
                  <v-text-field v-else
                    class="centered-input"
                    placeholder="Last name *"
                    v-model="custom.last_name"            
                    required
                    :rules="[v => !!v || 'This is a required field']"
                    dense   
                    outlined
                    background-color="rgb(66,66,66,0.85)"                
                    style="padding-left:5px;color:lightgray;align:right;font-size:12px"
                  >  
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row
                class="ma-0 pa-0"
              >
                <v-col
                  style="padding:0px"
                  cols="12"
                  sm="6"
                > 
                  <vue-phone-number-input
                    v-model="custom.phone_number" 
                    placeholder="Phone number"
                    default-country-code="ZM"
                    required
                    dark
                    @update="getPhoneNumber"
                    no-example
                    style="padding-right:5px"
                  />
                </v-col>
                <v-col
                  style="padding:0px"
                  cols="12"
                  sm="6"
                >   
                  <v-menu
                    :v-model="menu2"
                    :close-on-content-click="true"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="computedDateFormatted"
                        placeholder="Effective date *"
                        readonly
                        required
                        outlined
                        background-color="rgb(66,66,66,0.85)"
                        @change="quote=true"
                        dense
                        :rules="[v => !!v || 'This is a required field']"
                        v-on="on"
                        style="padding-left:5px;color:lightgray;font-size:12px"
                      ></v-text-field>
                    </template>
                    <v-date-picker 
                      v-model="date" 
                      no-title 
                      @input="menu2 = false"
                      :allowed-dates="allowedDates"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row
                class="ma-0 pa-0"
              >
                <v-col
                  style="padding:0px"
                  cols="12"
                  sm="6"
                >       
                  <v-select              
                    :items="cover_list"
                    placeholder="Cover Type *"
                    v-model="fullQuote.vehicleDetails.cover_type"
                    item-text="text"
                    item-value="value"
                    @change="coverTypeChanged"
                    outlined
                    background-color="rgb(66,66,66,0.85)"
                    dense
                    required
                    :rules="[v => !!v || 'This is a required field']"
                    return-object  
                    style="padding-right:5px;color:lightgray;font-size:12px"                             
                  >
                  </v-select>
                </v-col>
                <v-col 
                  style="padding:0px"
                  cols="12"
                  sm="6"
                > 
                  <v-select             
                    :items="vehicle_list"
                    v-model="fullQuote.vehicleDetails.vehicle_type"
                    placeholder="Vehicle Type *"
                    @change="quote=true"
                    item-text="text"
                    item-value="value"
                    outlined
                    background-color="rgb(66,66,66,0.85)"
                    dense
                    return-object
                    required
                    :rules="[v => !!v || 'This is a required field']"    
                    style="padding-left:5px;color:lightgray;font-size:12px"          
                  >
                  </v-select>
                </v-col>    
              </v-row>  
              <v-container fluid>
                <p style="padding:0px">Number of Quarters</p>    
                <v-radio-group
                  v-model="fullQuote.num_of_quarters"
                  row
                  dense
                  required
                  :rules="[v => !!v || 'This is a required field']"
                  @change="quote=true"
                  dark
                  style="padding:0px"
                >
                  <v-radio
                    key="1"
                    label="1"
                    value="1"
                    color="blue"
                    dense
                  ></v-radio>
                  <v-radio
                    key="2"
                    label="2"
                    value="2"
                    color="blue"
                  ></v-radio>
                  <v-radio
                    key="3"
                    label="3"
                    value="3"
                    color="blue"
                  ></v-radio>
                  <v-radio
                    key="4"
                    label="4"
                    value="4"
                    color="blue"
                  ></v-radio>
                </v-radio-group>
              </v-container>
            </v-form> 
            </div>
            <v-divider></v-divider>            
            <v-btn
              text
              @click="validate(1);"
              outlined
              style="color:lightgray;border:1px solid lightgray"
            >
              Continue
            </v-btn>
            <v-btn 
              outlined
              style="margin-left:5px;color:lightgray;border:1px solid lightgray"
              text
              @click="closeProduct"
            >
              Cancel
            </v-btn>
          </v-stepper-content>
          <v-stepper-content dark step="2" style="height:380px">
            <div style="height:280px;font-size:14px;color:lightgray">
            <v-form class="ma-0 pa-0" ref="form2"> 
              <v-row class="ma-0 pa-0"
              >
                <v-col
                  style="padding:0px"
                  cols="12"
                  sm="6"
                >                 
                  <v-text-field
                    placeholder="Vehicle registration number *"
                    v-model="fullQuote.vehicleDetails.vehicle_reg"                      
                    required
                    :rules="[v => !!v || 'This is a required field']"
                    dense  
                    outlined
                    background-color="rgb(66,66,66,0.85)"          
                    style="padding-right:5px;color:lightgray;font-size:12px"
                  >  
                  </v-text-field>
                </v-col>
                <v-col
                  style="padding:0px"
                  cols="12"
                  sm="6"
                >  
                  <v-text-field
                    placeholder="Year of manufacture *"
                    v-model="fullQuote.vehicleDetails.year_of_manf"                      
                    required
                    :rules="[v => !!v || 'This is a required field']"
                    dense            
                    type="number"
                    min="1980"
                    max="2020"
                    outlined
                    background-color="rgb(66,66,66,0.85)"          
                    style="padding-left:5px;color:lightgray;font-size:12px"
                  >  
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row
                class="ma-0 pa-0"
              >
                <v-col
                  style="padding:0px"
                  cols="12"
                  sm="6"
                >       
                  <v-text-field
                    placeholder="Engine number *"
                    v-model="fullQuote.vehicleDetails.engine_number"
                    required
                    :rules="[v => !!v || 'This is a required field']"
                    dense                
                    outlined
                    background-color="rgb(66,66,66,0.85)"          
                    style="padding-right:5px;color:lightgray;font-size:12px"             
                  >  
                  </v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  style="padding:0px"
                >             
                  <v-text-field
                    placeholder="Chassis number *"  
                    v-model="fullQuote.vehicleDetails.chassis_number"                     
                    dense
                    required
                    :rules="[v => !!v || 'This is a required field']"
                    outlined
                    background-color="rgb(66,66,66,0.85)"          
                    style="padding-left:5px;color:lightgray;font-size:12px"           
                  > 
                  </v-text-field>
                </v-col>       
              </v-row>
              <v-row
                class="ma-0 pa-0"
              >
                <v-col
                  cols="12"
                  sm="3"
                  style="padding:0px"
                >   
                  <!--<v-autocomplete
                    v-model="fullQuote.vehicleDetails.vehicle_make"
                    :items="makes"
                    dense
                    placeholder="Vehicle Make *"
                    required
                    outlined
                    background-color="rgb(66,66,66,0.85)"          
                    style="padding-right:5px;color:lightgray;font-size:12px"
                    :rules="[v => !!v || 'This is a required field']"
                  ></v-autocomplete>-->
                  <v-text-field
                    placeholder="Vehicle Make *"  
                    v-model="fullQuote.vehicleDetails.vehicle_make"                     
                    dense
                    required
                    :rules="[v => !!v || 'This is a required field']"
                    outlined
                    background-color="rgb(66,66,66,0.85)"          
                    style="padding-right:5px;color:lightgray;font-size:12px"           
                  > 
                  </v-text-field>   
                </v-col>
                <v-col
                  cols="12"
                  sm="3"
                  style="padding:0px"
                > 
                  <!--<v-autocomplete
                    v-model="fullQuote.vehicleDetails.vehicle_model"
                    :items="models"
                    dense
                    placeholder="Vehicle Model *"
                    required
                    outlined
                    background-color="rgb(66,66,66,0.85)"          
                    style="padding-right:5px;color:lightgray;font-size:12px"
                    :rules="[v => !!v || 'This is a required field']"
                  ></v-autocomplete>-->
                  <v-text-field
                    placeholder="Vehicle Model *"  
                    v-model="fullQuote.vehicleDetails.vehicle_model"                     
                    dense
                    required
                    :rules="[v => !!v || 'This is a required field']"
                    outlined
                    background-color="rgb(66,66,66,0.85)"          
                    style="padding-left:5px;color:lightgray;font-size:12px"           
                  > 
                  </v-text-field>             
                </v-col>       
                <v-col
                  cols="12"
                  sm="6"
                  style="padding:0px"
                >           
                  <v-text-field
                    placeholder="Color *"
                    v-model="fullQuote.vehicleDetails.vehicle_color"
                    required
                    :rules="[v => !!v || 'This is a required field']"
                    dense                                
                    outlined
                    background-color="rgb(66,66,66,0.85)"          
                    style="padding-left:5px;color:lightgray;font-size:12px"
                  >        
                  </v-text-field>
                </v-col>
              </v-row>    
              <v-row
                class="ma-0 pa-0"
              >
                <v-col
                  cols="12"
                  sm="3"
                  class="ma-0 pa-0"
                >           
                  <v-select   
                    v-if="(fullQuote.vehicleDetails.cover_type != null && fullQuote.vehicleDetails.cover_type.value === 'COMP')"          
                    :items="currency_list"
                    placeholder="Currency *"
                    v-model="fullQuote.currency"
                    item-text="text"
                    item-value="value"
                    @change="quote=true"
                    dense                      
                    return-object  
                    required
                    :rules="[v => !!v || 'This is a required field']"
                    outlined
                    background-color="rgb(66,66,66,0.85)"          
                    style="padding-right:5px;color:lightgray;font-size:12px"                           
                  >
                  </v-select>
                </v-col>
                <v-col
                  cols="12"
                  sm="3"
                  style="padding:0px"
                >           
                  <v-text-field
                    v-if="(fullQuote.vehicleDetails.cover_type != null && fullQuote.vehicleDetails.cover_type.value === 'COMP')"         
                    placeholder="Sum insured *"
                    v-model="fullQuote.estimated_value"
                    @change="insuredAmountChanged"
                    type="number"
                    min="15000"
                    step="100"
                    dense           
                    required
                    :rules="[v => !!v || 'This is a required field']"                     
                    outlined
                    background-color="rgb(66,66,66,0.85)"          
                    style="padding-right:5px;color:lightgray;font-size:12px" 
                  >        
                  </v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  class="ma-0 pa-0"
                >                    
                  <template>
                    <v-file-input style="padding-left:5px" accept="image/*" label="Upload Photos" prepend-icon="mdi-camera" outlined dense></v-file-input>
                  </template>
                </v-col>
              </v-row>
            </v-form>
            </div>
            <v-divider></v-divider>
            <v-btn
              text
              @click="validate(2);getPremium()"
              outlined
              style="color:lightgray;border:1px solid lightgray"
            >
              Continue
            </v-btn>
            <v-btn 
              text
              @click="e1 = 1"
              outlined
              style="margin-left:5px;color:lightgray;border:1px solid lightgray"
            >
              Previous
            </v-btn>
          </v-stepper-content>
          <v-stepper-content dark step="3" style="height:380px">
            <div v-if="outOfRange==true" style="height:280px;color:lightgray;font-size:12px">
              <p v-if="fullQuote.currency != null">
                Your Insured Amount of {{ fullQuote.currency.text }} {{ fullQuote.estimated_value }} can not be processed on our Website.
              </p>
              <p>
                For more information, kindly contact Professional Insurance Customer Care on<br /><br /><strong>Email:</strong> customerservice@picz.co.zm<br /><strong>Phone:</strong> 0211366705<br /> <strong>Whatsapp:</strong> 0956659857
              </p>
            </div>
            <div v-else style="height:280px;font-size:12px">
            <v-form ref="form"> 
              <div style="color:white" class="pa-0 ma-0">Client Details</div> 
              <v-row
                class="ma-0 pa-0"
              >
                <v-col
                class="ma-0 pa-0"
                cols="12"
                sm="6"
                >
                  <v-simple-table dense style="background-color:transparent" height="50px">
                    <thead>
                      <tr>
                        <th width="60%" v-if="user.loggedIn" class="text-left"> {{ user.data.first_name }} {{ user.data.last_name }} </th>
                        <th width="60%" v-else class="text-left"> {{ custom.first_name }} {{ custom.last_name }} </th>
                        <th v-if="user.loggedIn" class="text-left"> {{ user.data.phone_number }} </th>
                        <th v-else class="text-left"> {{ custom.phone_number }} </th>
                      </tr>
                    </thead>
                  </v-simple-table> 
                </v-col>
                <v-col
                class="ma-0 pa-0"
                cols="12"
                sm="6"
                style="text-align:right"
                >
                  <v-btn 
                    text
                    @click="downloadQuotation"
                    outlined
                    style="margin-right:5px;color:lightgray;border:1px solid lightgray"              
                  >
                    Download Quotation
                  </v-btn>
                </v-col> 
              </v-row>             
              <div class="pa-0 ma-0" style="color:white">Vehicle Details</div>          
              <v-simple-table dense style="background-color:transparent" height="80px">
                <thead>
                  <tr>
                    <th class="text-left">Type</th>
                    <th class="text-left">Reg#</th>
                    <th class="text-left">Model</th>
                    <th class="text-left">Engine#</th>
                    <th class="text-left">Chasis#</th>
                    <th class="text-left">Color</th>
                    <th v-if="fullQuote.vehicleDetails.cover_type != null && fullQuote.vehicleDetails.cover_type.value == 'COMP'" class="text-left">Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td v-if="fullQuote.vehicleDetails.vehicle_type != null" style="font-size:10px">{{ fullQuote.vehicleDetails.vehicle_type.text }}</td>
                    <td style="font-size:10px">{{ fullQuote.vehicleDetails.vehicle_reg }}</td>
                    <td style="font-size:10px">{{ fullQuote.vehicleDetails.vehicle_make }} {{ fullQuote.vehicleDetails.vehicle_model }}</td>
                    <td style="font-size:10px">{{ fullQuote.vehicleDetails.engine_number }}</td>
                    <td style="font-size:10px">{{ fullQuote.vehicleDetails.chassis_number }}</td>
                    <td style="font-size:10px">{{ fullQuote.vehicleDetails.vehicle_color }}</td>
                    <td v-if="fullQuote.vehicleDetails.cover_type != null && fullQuote.vehicleDetails.cover_type.value == 'COMP'" style="font-size:10px">{{ fullQuote.estimated_value }}</td>
                  </tr>
                </tbody>
              </v-simple-table>      
              <div v-if="fullQuote.currency != null&&fullQuote.vehicleDetails.cover_type != null" style="color:white">Motor {{ fullQuote.vehicleDetails.cover_type.text }} Quotation Details ({{ fullQuote.currency.text }})</div>
              <v-simple-table dense style="background-color:transparent" width="100%" height="80px">
                <thead>
                  <tr>
                    <th class="text-left">Start</th>
                    <th class="text-left">End</th>
                    <th class="text-left">Qtrs</th>
                    <th v-if="fullQuote.vehicleDetails.cover_type != null && fullQuote.vehicleDetails.cover_type.value == 'COMP'" class="text-left" style="color:orange">Rate</th>
                    <th class="text-left" style="color:orange">Base</th>
                    <th class="text-left" style="color:orange">Levy</th>
                    <th class="text-left" style="color:orange">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style="font-size:10px">{{ custom.start_date }}</td>
                    <td style="font-size:10px">{{ fullQuote.end_date }}</td>
                    <td style="font-size:10px">{{ fullQuote.num_of_quarters }}</td>
                    <td v-if="fullQuote.vehicleDetails.cover_type != null && fullQuote.vehicleDetails.cover_type.value == 'COMP'" style="font-size:10px"><b>{{ fullQuote.rate }}%</b></td>
                    <td style="font-size:10px"><b>{{ fullQuote.base }}</b></td>
                    <td style="font-size:10px"><b>{{ fullQuote.levy }}</b></td>
                    <td style="font-size:10px"><b>{{ fullQuote.premium }}</b></td>
                  </tr>
                </tbody>
              </v-simple-table> 
              <v-row
                class="ma-0 pa-0"
              >
                <v-col
                  class="pa-0 ma-0"
                  cols="12"
                  sm="1"
                >
                  <v-checkbox 
                    style="padding:0px;margin:0px"
                    class="mx-2"
                    color="blue"
                    v-model="accepted"  
                  >
                  </v-checkbox> 
                </v-col>
                <v-col
                  class="pa-0 ma-0"
                  cols="12"
                  sm="11"
                >
                  <p style="color:white;font-size:12px;padding-top:5px">I Accept the <a style="color:yellowgreen" href="/terms" target="_blank">PICZ Terms of Use</a></p>
                </v-col>
              </v-row>
            </v-form>
            </div>
            <v-divider></v-divider>
            <!--<v-btn v-if="outOfRange == false"
              text
              @click="getDeliveryInfo"
              outlined
              style="margin-right:5px;color:lightgray;border:1px solid lightgray"              
            >
              Make Payment
            </v-btn>-->
            <CheckoutModal v-if="user.loggedIn && outOfRange == false"
              :isProduction="isProduction"
              :email="user.data.email_address"
              :amount="parseFloat(fullQuote.premium)"
              :reference="reference"
              :rave-key="raveKey"
              :callback="callback"
              :close="close"
              :currency="currency"
              :country="country"         
              :payment_method="paymentMethod"
              :form="$refs.form4"
              :accepted="accepted"
            />
            <CheckoutModal v-if="user.loggedIn == false && outOfRange == false"
              color="primary"
              :isProduction="isProduction"
              :email="custom.email_address"
              :amount="parseFloat(fullQuote.premium)"
              :reference="reference"
              :rave-key="raveKey"
              :callback="callback"
              :close="close"
              :currency="currency"
              :country="country"
              :payment_method="paymentMethod"
              :form="$refs.form4"
              :accepted="accepted"
            />
            <v-btn 
              text
              @click="previous"
              outlined
              style="margin-right:5px;margin-left:5px;color:lightgray;border:1px solid lightgray"              
            >
              Previous
            </v-btn>
            <v-btn v-if="outOfRange == false"
              text
              @click="openBottomSheet(6)"
              outlined
              style="color:lightgray;border:1px solid lightgray" 
            >
              View Benefits
            </v-btn>
            <v-btn v-if="outOfRange==true"
              outlined
              style="margin-left:5px;color:lightgray;border:1px solid lightgray"
              text
              @click="closeProduct"
            >
              Cancel
            </v-btn>
          </v-stepper-content>
        </v-stepper-items>
     </v-stepper>
    </div>
    <div v-else style="padding-top:10px;padding-left:10px;padding-right:10px">
      <div
        style="background-color:transparent;height:330px;padding-left:20px;padding-right:20px;padding-top:0px;padding-bottom:20px"
      >
        <v-form ref="form4">
          <v-row class="ma-0 pa-0"
          >
            <v-col
              class="ma-0 pa-0"
              cols="12"
              sm="6"
              style="background-color:transparent"
            >                   
              <v-text-field v-if="user.loggedIn"
                placeholder="First name *"                        
                v-model="user.data.first_name"                    
                required
                :rules="[v => !!v || 'This is a required field']"
                dense            
                outlined
                background-color="rgb(66,66,66,0.85)"          
                style="padding-right:5px;color:lightgray;font-size:12px"
              >  
              </v-text-field>
              <v-text-field v-else
                placeholder="First name *"                        
                v-model="custom.first_name"                    
                required
                :rules="[v => !!v || 'This is a required field']"
                dense            
                outlined
                background-color="rgb(66,66,66,0.85)"          
                style="padding-right:5px;color:lightgray;font-size:12px"
              >  
              </v-text-field>
            </v-col>
            <v-col 
              class="ma-0 pa-0"
              cols="12"
              sm="6"
            > 
              <v-text-field v-if="user.loggedIn"
                placeholder="Last name *"
                v-model="user.data.last_name"                      
                required
                :rules="[v => !!v || 'This is a required field']"
                dense                       
                outlined
                background-color="rgb(66,66,66,0.85)"          
                style="padding-left:5px;color:lightgray;font-size:12px"
              >  
              </v-text-field>
              <v-text-field v-else
                placeholder="Last name"
                v-model="custom.last_name"                      
                required
                :rules="[v => !!v || 'This is a required field']"
                dense                       
                outlined
                background-color="rgb(66,66,66,0.85)"          
                style="padding-left:5px;color:lightgray;font-size:12px"
              >  
              </v-text-field>
            </v-col>
          </v-row>
          <v-row
            class="ma-0 pa-0"
          >
            <v-col
              class="ma-0 pa-0"
              cols="12"
              sm="6"
            >    
              <v-text-field v-if="user.loggedIn"
                placeholder="Email address"
                v-model="user.data.email_address"                  
                required
                :rules="[v => !!v || 'This is a required field']"
                dense            
                outlined
                background-color="rgb(66,66,66,0.85)"          
                style="padding-right:5px;color:lightgray;font-size:12px"
              >  
              </v-text-field>
              <v-text-field v-else
                placeholder="Email address *"
                v-model="custom.email_address"                  
                required
                :rules="[v => !!v || 'This is a required field']"
                dense            
                outlined
                background-color="rgb(66,66,66,0.85)"          
                style="padding-right:5px;color:lightgray;font-size:12px"
              >  
              </v-text-field>
            </v-col>
            <v-col
              class="ma-0 pa-0"
              cols="12"
              sm="6"
            >  
              <vue-phone-number-input
                v-model="custom.phone_number" 
                placeholder="Phone number"
                default-country-code="ZM"
                required
                dark
                @update="getPhoneNumber"
                no-example
                style="padding-left:5px"
              />
            </v-col>
          </v-row>
          <v-row
            class="ma-0 pa-0"
          >
            <v-col
              class="ma-0 pa-0"
              cols="12"
              sm="3"
            >       
              <v-select              
                v-model="custom.province"
                placeholder="Province"
                :items="province_list"
                item-text="text"
                item-value="value"
                required
                :rules="[v => !!v || 'This is a required field']"
                dense
                return-object  
                outlined
                background-color="rgb(66,66,66,0.85)"          
                style="padding-right:5px;color:lightgray;font-size:12px"                        
              >
              </v-select>
            </v-col>
            <v-col 
              class="ma-0 pa-0"
              cols="12"
              sm="3"
            > 
              <v-select             
                :items="city_list"
                placeholder="City/Town"
                v-model="custom.city"
                item-text="text"
                item-value="value"
                required
                :rules="[v => !!v || 'This is a required field']"
                dense
                @change="cityChanged"
                return-object                     
                outlined
                background-color="rgb(66,66,66,0.85)"          
                style="padding-right:5px;color:lightgray;font-size:12px"       
              >
              </v-select>
            </v-col>    
            <v-col
              class="ma-0 pa-0"
              cols="12"
              sm="6"
            >       
              <v-select         
                v-bind:disabled="disabled"     
                v-model="custom.zone"
                placeholder="Zone"
                :items="zone_list"
                item-text="zone"
                item-value="fee"
                dense                    
                return-object  
                outlined
                background-color="rgb(66,66,66,0.85)"          
                style="padding-left:5px;color:lightgray;font-size:12px"
                @change="deliveryChanged()"                           
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row
            class="ma-0 pa-0"
          >
            <v-col 
              style="padding:0px"
              cols="12"
              sm="6"
            > 
              <v-text-field
                placeholder="Physical Address"
                v-model="custom.physical_address"                
                dense 
                outlined
                background-color="rgb(66,66,66,0.85)"          
                style="padding-right:5px;color:lightgray;font-size:12px"                              
              >  
              </v-text-field>
            </v-col>    
            <v-col
              class="ma-0 pa-0"
              cols="12"
              sm="3"
            >    
              <v-menu
                :v-model="menu2"
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="computedDateFormatted"
                    placeholder="Delivery date *"
                    readonly
                    
                    outlined
                    background-color="rgb(66,66,66,0.85)"
                    @change="quote=true"
                    dense
                    
                    v-on="on"
                    style="padding-left:5px;color:lightgray;font-size:12px"
                  ></v-text-field>
                </template>
                <v-date-picker 
                  v-model="date" 
                  no-title 
                  @input="menu2 = false"
                  :allowed-dates="allowedDates"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col
              class="ma-0 pa-0"
              cols="12"
              sm="3"
            >   
              <v-text-field
                placeholder="Delivery Time"
                v-model="custom.delivery_time"
                type="time"
                
                dense            
                outlined
                background-color="rgb(66,66,66,0.85)"          
                style="padding-left:5px;color:lightgray;font-size:12px"                      
              >  
              </v-text-field>
            </v-col>
          </v-row>
          <v-row
            class="ma-0 pa-0"
          >
            <v-col
              class="ma-0 pa-0"
              cols="12"
              sm="6"
            > 
              <v-checkbox 
                v-bind:disabled="disabled" 
                style="padding:0px;margin:0px"
                class="mx-2"
                color="orange"
                v-model="optIn"  
                @change="deliveryChanged"
                label="Deliver Documents">
              </v-checkbox>
            </v-col>
            <v-col
              class="ma-0 pa-0"
              cols="12"
              sm="3"
            >  
              <div style="padding:0px;margin:0px;color:orange;text-align:right"><b>Delivery Fee:</b></div>
            </v-col>
            <v-col
              class="ma-0 pa-0"
              cols="12"
              sm="3"
            >   
              <div style="padding-left:10px;padding-top:0px;padding-bottom:0px;margin_left:10px;text-align:left;color:white"><b>K {{ fullQuote.delivery_fee }}</b></div>
            </v-col>
          </v-row>
        </v-form>             
    </div> 
    <v-divider></v-divider>
    <div style="margin-left:25px">
      <CheckoutModal v-if="user.loggedIn"
          :isProduction="isProduction"
          :email="user.data.email_address"
          :amount="parseFloat(fullQuote.total_bill)"
          :reference="reference"
          :rave-key="raveKey"
          :callback="callback"
          :close="close"
          :currency="currency"
          :country="country"         
          :payment_method="paymentMethod"
          :form="$refs.form4"
          :accepted="accepted"
        />
        <CheckoutModal v-else
          color="primary"
          :isProduction="isProduction"
          :email="custom.email_address"
          :amount="parseFloat(fullQuote.total_bill)"
          :reference="reference"
          :rave-key="raveKey"
          :callback="callback"
          :close="close"
          :currency="currency"
          :country="country"
          :payment_method="paymentMethod"
          :form="$refs.form4"
          :accepted="accepted"
        />
        <v-btn 
          text
          outlined
          style="margin-left:5px"
          @click="closeProduct"
        >
          Cancel
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from "axios";
  import { mapGetters } from "vuex";
  import CheckoutModal from "@/components/modals/CheckoutModal.vue";
  import jsPDF from 'jspdf';
  import moment from 'moment'

  const raveKey = process.env.VUE_APP_RAVE_TEST_KEY;
  const GET_COMP_PRICE_URL = "http://139.59.131.242:4000/comp/getPrice/";
  const CREATE_COMP_QUOTE_URL = "http://139.59.131.242:4000/comp/createQuotation/";
  const AUTHORIZE_COMP_QUOTE_URL = "http://139.59.131.242:4000/comp/authorize/";
  const GET_TP_PRICE_URL = "http://139.59.131.242:4000/tp/getPrice/";
  const CREATE_TP_QUOTE_URL = "http://139.59.131.242:4000/tp/createQuotation/";
  const AUTHORIZE_TP_QUOTE_URL = "http://139.59.131.242:4000/tp/authorize/";
  const DELIVERY_URL = "https://afridelivery.com/pro_insurance/api/";
  const GET_POLICIES_URL = "http://139.59.131.242:4000/client/allClientPolicies";

  export default {
    name: 'MotorQuote',
    components: {
      CheckoutModal
    },
    data: () => ({
      e1: 1,
      steps: 3,
      currency_list: [
        { text: 'ZMW', value: 'ZMW' },
        { text: 'USD', value: 'USD' }
      ],
      cover_list: [
        { text: 'Comprehensive', value: 'COMP' },
        { text: 'Full Third Party', value: 'FTP' }
      ],
      vehicle_list: [
        { text: 'Private', value: '1'},
        { text: 'Commercial', value: '2'},
        { text: 'Bus/Taxi', value: '3'}
      ],
      makes: [
       'TOYOTA',
       'MAZDA',
       'MERCEDES',
       'NISSAN',
       'HYUNDAI',
       'LAND ROVER',
       'BMW',
       'VOLSWAGEN',
       'AUDI',
      ],
      models: [
       'HILUX',
       'COROLLA',
       'CORONA',
       'AVENSIS',
       'RUNX',
       'ALLEX',
       'PREMIO',
       'BREVIS',
       'MARKX',
      ],
      loading: false,
      quotation_id: 0,
      custom: {
        first_name: '',
        last_name: '',
        email_address: '',
        phone_number: '',
        start_date: '',
        zone: {
          id: 0,
          zone: '',
          fee: ''
        },
        province: null,
        city: null,
        physical_address: '',
        delivery_date: '',
        delivery_time: '',
        coordinates: {
          latitude: '',
          longitude: ''
        },
      },
      dialog: false,
      isProduction: false,
      raveKey: raveKey,
      amount: "",
      currency: "",
      country: "",
      paymentMethod: "",
      delivery: false,
      province_list: [
        { text: 'Lusaka', value: '1' },
        { text: 'Copperbelt', value: '2' },
        { text: 'Eastern', value: '3' },
        { text: 'Central', value: '4' },
        { text: 'Northen', value: '5' },
        { text: 'North-Western', value: '6' },
        { text: 'Southern', value: '7' },
        { text: 'Luapula', value: '8' },
        { text: 'Western', value: '9' },
        { text: 'Muchinga', value: '10' }
      ],
      city_list: [
        { text: 'Lusaka', value: '1' },
        { text: 'Ndola' , value: '2' },
        { text: 'Kitwe', value: '3' },
        { text: 'Chingola', value: '4' },
        { text: 'Luanshya', value: '5' },
        { text: 'Kalulushi', value: '6' },
        { text: 'Mufurila', value: '7' },
      ],
      zone_list: [],
      optIn: false,
      disabled: true,
      date: new Date().toISOString().substr(0, 10),
      menu2: false,
      quote: false,
      outOfRange: false,
      accepted: false
    }),
    watch: {
      steps (val) {
        if (this.e1 > val) {
          this.e1 = val
        }
      },
    },
    methods: {
      previous(){
        this.e1 = 2;
        this.quote = false;
      },
      allowedDates: val => moment(val).isSameOrAfter(new Date(), 'day'),
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      showAlert(text,variant){
        this.components.bootstrap_alert.dismissCountDown = this.components.bootstrap_alert.dismissSecs;
        this.components.bootstrap_alert.variant = variant;
        this.components.bootstrap_alert.alert_text = text;
      },
      deliveryChanged(){   
        if (this.custom.city.value == '1'){
          if (this.optIn === true){
            this.fullQuote.delivery_fee = this.custom.zone.fee;
          }else{
            this.fullQuote.delivery_fee = '0.00';
          }
        }
        
        this.fullQuote.total_bill = (parseFloat(this.fullQuote.delivery_fee) + parseFloat(this.fullQuote.premium)).toFixed(2);
      },
      cityChanged(){
        if (this.custom.city.value === '1'){
          this.disabled = false;
          //this.cancelled = false;
        }else{
          this.disabled = true;
          this.custom.zone = null;
          //this.cancelled = true;
          this.fullQuote.delivery_fee = '0.00';
        }

        this.fullQuote.total_bill = (parseFloat(this.fullQuote.delivery_fee) + parseFloat(this.fullQuote.premium)).toFixed(2);
      },
      insuredAmountChanged(){
        var amount = parseFloat(this.fullQuote.estimated_value);
        
        if (this.fullQuote.currency != null && this.fullQuote.currency.text == 'ZMW' && (amount < 15000 || amount > 1000000)){
          this.outOfRange = true;
        }else if (this.fullQuote.currency != null && this.fullQuote.currency.text == 'USD' &&(amount < 1000 || amount > 400000)){
          this.outOfRange = true;
        }else{
          this.quote = true;
          this.outOfRange = false;
        }
      },
      coverTypeChanged(){
        this.quote = true;
        if (this.fullQuote.vehicleDetails.cover_type != null && this.fullQuote.vehicleDetails.cover_type.value == 'FTP'){
          if (this.fullQuote.currency != null){
            this.fullQuote.currency.text = 'ZMW';
          }else{
            this.fullQuote.currency = this.currency_list;
            this.fullQuote.currency.text = 'ZMW';
          }
          this.components.nav_drawer.sub_product_index = 1;
        }else{
          this.fullQuote.currency = null;
          this.components.nav_drawer.sub_product_index = 0;
        }        
      },
      getDeliveryInfo(){
        if (this.accepted == true){
          this.delivery=!this.delivery

          var data = {
            "token": "prnu6bp6d2lniqja13xtaz",
            "task": "get_zones_and_fees",
          }

          axios
          .post(DELIVERY_URL,JSON.stringify(data))
          .then(response => {
            this.zone_list = response.data;
          })
          .catch(error => {
            console.log('Error',error);
          });
        }else{
          this.showAlert('Please Accept the PICZ Terms of Use!','danger')
        }
      },
      validate(step){
        if (step == "1"){
          if (this.$refs.form1.validate()){
            this.e1 = parseInt(step) + 1;
          }
        }
        if (step == "2"){
          if (this.$refs.form2.validate()){
            this.e1 = parseInt(step) + 1;
          }
        }
      },
      onInput (val) {
        this.steps = parseInt(val)
      },
      nextStep (n) {
        if (n === this.steps) {
          this.e1 = 1
        } else {
          this.e1 = n + 1
        }
      },
      closeProduct(){
        this.components.nav_drawer.product_index=0;
        this.components.nav_drawer.sub_product_index=0;
        this.components.nav_drawer.mini_variant=true;
        this.components.nav_drawer.expand_on_hover=true;
      },
      getPremium(){ 
        //console.log(this.date);
        if (this.outOfRange){
          this.showAlert('Quotation creation unsuccessful!','danger');
        }else if (this.quote == true && this.outOfRange == false){
          var start_date = this.formatDate(this.date)
          
          this.fullQuote.start_date = start_date;

          var start_month = this.$moment(this.date).month() + 1;

          if (this.fullQuote.currency.text == "ZMW"){
            this.currency = "ZMW";
            this.country = "ZM";
          }else if (this.fullQuote.currency.text == "USD"){
            this.currency = "USD";
            this.country = "NG";
          }
          
          var start_quarter = 0;
          // get starting quarter
          if (start_month <= 2){
            start_quarter = 1;
          }
          if ((start_month > 2)&&((start_month <= 5))){
            start_quarter = 2;
          }
          if ((start_month > 5)&&((start_month <= 8))){
            start_quarter = 3;
          }
          if (start_month >= 9){
            start_quarter = 4;
          }
          
          var end_quarter = 0;
          var end_date = '';
          var end_year = this.$moment(this.date).year();
          
          this.custom.start_date = start_date;

          end_quarter = start_quarter + parseInt(this.fullQuote.num_of_quarters) - 1;

          if (end_quarter > 4){
            end_year = end_year + 1;
            end_quarter = end_quarter - 4;
            if (end_quarter == 1){
              end_date = '31/03/' + end_year;
            }
            if (end_quarter == 2){
              end_date = '30/06/' + end_year;
            }
            if (end_quarter == 3){
              end_date = '30/09/' + end_year;
            }
            if (end_quarter == 0){
              end_quarter = 4;
              end_date = '31/12/' + end_year;
            }
          }else{
            end_year = this.$moment(this.date).year();
            if (end_quarter == 1){
              end_date = '31/03/' + end_year;
            }
            if (end_quarter == 2){
              end_date = '30/06/' + end_year;
            }
            if (end_quarter == 3){
              end_date = '30/09/' + end_year;
            }
            if (end_quarter == 4){
              end_date = '31/12/' + end_year;
            }
          }
          
          this.fullQuote.end_date = end_date;
          var data = null;
          
          if (this.fullQuote.vehicleDetails.cover_type.value == 'FTP'){
            data = {
              num_of_quarters: this.fullQuote.num_of_quarters,
              product_type_id: this.fullQuote.vehicleDetails.vehicle_type.value,
              digital_channel_id: 1
            };
            //console.log(data);
            axios
            .get(GET_TP_PRICE_URL,{params:data},)
            .then(response => {
              var premium = parseFloat(response.data.premium);
              this.fullQuote.premium = premium;
              var levy = 3/100 * premium;
              var base = premium - levy;
              this.fullQuote.levy = levy.toFixed(2);
              this.fullQuote.base = base.toFixed(2);

              // create quotation
              var full_name = "";

              if (this.user.loggedIn){
                full_name = this.user.data.first_name + " " + this.user.data.last_name;
              }else{
                full_name = this.custom.first_name + " " + this.custom.last_name;
              }

              const quote = {
                digital_channel: 1,
                product_type_id: this.fullQuote.vehicleDetails.vehicle_type.value,
                client_id: this.user.data.client_id,
                client_type: "individual_client",
                num_of_quarters: this.fullQuote.num_of_quarters,
                start_date: this.custom.start_date,
                end_date: this.fullQuote.end_date,
                currency: this.fullQuote.currency.text,
                total_premium_due: this.fullQuote.premium,
                created_by: this.user.data.user_id,
                authorised_by: this.user.data.user_id,
                agency_id: 44,
                vehicles: [
                  {
                    insured_names: full_name,
                    start_date: this.custom.start_date,
                    end_date: this.fullQuote.end_date,
                    vehicle_make: this.fullQuote.vehicleDetails.vehicle_make,
                    vehicle_model: this.fullQuote.vehicleDetails.vehicle_model,
                    num_of_quarters: this.fullQuote.num_of_quarters,
                    year_of_manufacture: this.fullQuote.vehicleDetails.year_of_manf,
                    vehicle_reg_number: this.fullQuote.vehicleDetails.vehicle_reg,
                    vehicle_engine_number: this.fullQuote.vehicleDetails.engine_number,
                    vehicle_chassis_number: this.fullQuote.vehicleDetails.chassis_number,
                    vehicle_colour: this.fullQuote.vehicleDetails.vehicle_color,
                    premium_due: this.fullQuote.premium
                  }
                ]
              }
              //console.log(quote);
              axios
              .post(CREATE_TP_QUOTE_URL, quote)
              .then(response => {
                if (response.data.id > 0){
                  this.showAlert('Quotation created successfully!','success')
                  this.quotation_id = response.data.id;   
                }        
              })
              .catch(error => {
                  console.log('Error', error);
                  this.loading = false;
              });
            })
            .catch(error => {
                console.log('Error', error);
            }); 

          }else{
            data = {
              start_date: this.custom.start_date,
              end_date: this.fullQuote.end_date,
              sum_insured: parseFloat(this.fullQuote.estimated_value),
              digital_channel: 2,
              product_type_id: this.fullQuote.vehicleDetails.vehicle_type.value,
            };

            axios
            .get(GET_COMP_PRICE_URL,{params:data},)
            .then(response => {
              var premium = parseFloat(response.data.premium);
              this.fullQuote.rate = parseFloat(response.data.rate);
              this.fullQuote.discount = (parseFloat(response.data.discount)).toFixed(2);

              var levy = (parseFloat(this.fullQuote.rate))/100 * premium;
              var base = premium - levy;
              this.fullQuote.premium = premium.toFixed(2);
              this.fullQuote.levy = levy.toFixed(2);
              this.fullQuote.base = base.toFixed(2);
              
              // create quotation
              var full_name = "";

              if (this.user.loggedIn){
                full_name = this.user.data.first_name + " " + this.user.data.last_name;
              }else{
                full_name = this.custom.first_name + " " + this.custom.last_name;
              }

              const quote = {
                digital_channel: 2,
                product_type_id: this.fullQuote.vehicleDetails.vehicle_type.value,
                client_id: this.user.data.client_id,
                start_date: this.custom.start_date,
                end_date: this.fullQuote.end_date,
                total_premium_due: this.fullQuote.premium,
                created_by: this.user.data.user_id,
                authorised_by: this.user.data.user_id,
                agency_id: 44,
                vehicles: [
                  {
                    insured_names: full_name,
                    start_date: this.custom.start_date,
                    end_date: this.fullQuote.end_date,
                    vehicle_make: this.fullQuote.vehicleDetails.vehicle_make,
                    vehicle_model: this.fullQuote.vehicleDetails.vehicle_model,
                    year_of_manufacture: this.fullQuote.vehicleDetails.year_of_manf,
                    vehicle_reg_number: this.fullQuote.vehicleDetails.vehicle_reg,
                    vehicle_engine_number: this.fullQuote.vehicleDetails.engine_number,
                    vehicle_chassis_number: this.fullQuote.vehicleDetails.chassis_number,
                    vehicle_colour: this.fullQuote.vehicleDetails.vehicle_color,
                    sum_insured: this.fullQuote.estimated_value,
                    rate: this.fullQuote.rate,
                    discount: 0,
                    premium_due: this.fullQuote.premium
                  }
                ]
              }
              
              axios
              .post(CREATE_COMP_QUOTE_URL, quote)
              .then(response => {
                if (response.data.id > 0){
                  this.showAlert('Quotation created successfully!','success')
                  this.quotation_id = response.data.id;    
                }        
              })
              .catch(error => {
                  console.log('Error', error);
                  this.loading = false;
              });
            })
            .catch(error => {
                console.log('Error', error);
            });  
          }
        }               
      },
      refreshPolicies(){
        const client = {
          id: this.user.data.client_id
        }
        axios
        .get(GET_POLICIES_URL, { params:client })
        .then(response => {
          if (response.status == 200){
            this.policies.oti = response.data.oti;
            this.policies.houseowners = response.data.houseowners;
            this.policies.comprehensive = response.data.comprehensive;
            this.policies.thirdparty = response.data.thirdparty;
            this.policies.muendebwino = response.data.muendebwino;
            console.log(this.policies);
          }
        })
        .catch(error => {
          console.log(error);
        }); 
      },
      makeDelivery(){
        var notes = '';
        var full_name = "";
        var email_address = "";
        var phone_number = "";

        if (this.product_type === 'MOTOR'){
          notes = "Motor " + this.fullQuote.vehicleDetails.cover_type.text + " Insurance policy documents for " + this.custom_fname + " " + this.custom_lname;
        }

        if (this.user.loggedIn){
          full_name = this.user.data.first_name + " " + this.user.data.last_name;
          email_address = this.user.data.email_address;
          phone_number = this.user.data.phone_number;
        }else{
          full_name = this.custom.first_name + " " + this.custom.last_name;
          email_address = this.custom.email_address;
          phone_number = this.custom.phone_number;
        }
        
        var data = {
          "token": "prnu6bp6d2lniqja13xtaz",
          "task": "new_delivery",
          "reference": this.reference,
          "name": full_name,
          "location": this.custom.physical_address,
          "zone_id": this.custom.zone.id,
          "number": phone_number,
          "email": email_address,
          "lat": this.custom.coordinates.latitude,
          "lng": this.custom.coordinates.longitude,
          "notes": notes
        }

        axios
        .post(DELIVERY_URL,JSON.stringify(data))
        .then(response => {
          //TO DO
          console.log(response);
        })
        .catch(error => {
          console.log('Error',error);
        });
      },
      callback: function(response) {
        //console.log(response);
        if (response.data.tx.status == "successful" &&  response.data.tx.chargeResponseCode === "00") {
          if (response.data.tx.fraud_status === "ok") {
            this.txref = response.tx.txRef

            var data = null;
            
            // create policy
            if (this.fullQuote.vehicleDetails.cover_type.value == 'FTP'){
              data = {
                "id": this.quotation_id,
                "digital_channel": 2
              }

              axios
              .post(AUTHORIZE_TP_QUOTE_URL, data)
              .then(response => {
                if (response != null){
                  this.fullQuote.policy_number = response.data;
                  this.closeProduct();
                  this.certificate(); 
                  if (this.optIn == true){
                    this.makeDelivery();
                  }
                  this.refreshPolicies();
                  this.fullQuote.vehicleDetails.cover_type = null;
                  this.fullQuote.vehicleDetails.vehicle_type = null;
                  this.fullQuote.vehicleDetails.vehicle_reg = '';
                  this.fullQuote.vehicleDetails.year_of_manf = '';
                  this.fullQuote.vehicleDetails.engine_number = '';
                  this.fullQuote.vehicleDetails.chassis_number = '';
                  this.fullQuote.vehicleDetails.vehicle_make = '';
                  this.fullQuote.vehicleDetails.vehicle_color = '';
                  this.fullQuote.vehicleDetails.vehicle_model = '';
                  this.fullQuote.premium = '0.00';
                  this.fullQuote.levy = '0.00';
                  this.fullQuote.base = '0.00';
                  this.fullQuote.delivery_fee = '0.00';
                  this.fullQuote.start_date = '';
                  this.fullQuote.expiry_date = '';
                  this.fullQuote.total_bill = '0.00';
                  this.fullQuote.num_of_quarters = '';
                  this.fullQuote.currency = null;
                  this.fullQuote.estimated_value = '0.00';
                  this.fullQuote.id = 0;
                  this.fullQuote.estimated_value = '0.00';
                  this.custom.rate = '0';
                  this.custom.discount = '0.00';
                  this.custom.delivery_date = '';
                  this.outOfRange = false;
                  this.optIn = false;
                  this.components.nav_drawer.sub_product_index=0;
                }            
              })
              .catch(error => {
                  console.log('Error', error);
              });
            }else{
              data = {
                "id": this.quotation_id,
                "digital_channel": 2
              }

              axios
              .post(AUTHORIZE_COMP_QUOTE_URL, data)
              .then(response => {
                if (response != null){
                  this.fullQuote.policy_number = response.data;
                  if (this.optIn == true){
                    this.makeDelivery();
                  }
                  this.closeProduct();
                  this.certificate(); 
                  this.fullQuote.vehicleDetails.cover_type = null;
                  this.fullQuote.vehicleDetails.vehicle_type = null;
                  this.fullQuote.vehicleDetails.vehicle_reg = '';
                  this.fullQuote.vehicleDetails.year_of_manf = '';
                  this.fullQuote.vehicleDetails.engine_number = '';
                  this.fullQuote.vehicleDetails.chassis_number = '';
                  this.fullQuote.vehicleDetails.vehicle_make = '';
                  this.fullQuote.vehicleDetails.vehicle_color = '';
                  this.fullQuote.vehicleDetails.vehicle_model = '';
                  this.fullQuote.premium = '0.00';
                  this.fullQuote.levy = '0.00';
                  this.fullQuote.base = '0.00';
                  this.fullQuote.delivery_fee = '0.00';
                  this.fullQuote.start_date = '';
                  this.fullQuote.expiry_date = '';
                  this.fullQuote.total_bill = '0.00';
                  this.fullQuote.num_of_quarters = '';
                  this.fullQuote.currency = null;
                  this.fullQuote.estimated_value = '0.00';
                  this.fullQuote.id = 0;
                  this.fullQuote.estimated_value = '0.00';
                  this.custom.rate = '0';
                  this.custom.discount = '0.00';
                  this.custom.delivery_date = '';
                  this.outOfRange = false;
                  this.optIn = false;
                  this.refreshPolicies();
                  this.$router.push('/dashboard')
                }            
              })
              .catch(error => {
                  console.log('Error', error);
              });         
            }   
          }
        } else {
            console.log("Your payment could not be processed. Please try again later");
        }
      },
      close: function(){},
      openBottomSheet(index){
        this.components.bottom_sheet.option_index=index;
        this.components.bottom_sheet.is_open=true;
      },
      certificate() {        
        var first_name = '';
        var last_name = '';
        var email_address = '';

        if (this.user.loggedIn){
          first_name = this.user.data.first_name;
          last_name = this.user.data.last_name;
          email_address = this.user.data.email_address;
        }else{
          first_name = this.custom.first_name;
          last_name = this.custom.last_name;
          email_address = this.custom.email_address;
        }
        
        var doc = new jsPDF();
        var x=0;
        var y=0;

        var imgData = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/4RCaRXhpZgAATU0AKgAAAAgABAE7AAIAAAANAAAISodpAAQAAAABAAAIWJydAAEAAAAaAAAQeOocAAcAAAgMAAAAPgAAAAAc6gAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAE1pa2UgTXV5ZW1iZQAAAAHqHAAHAAAIDAAACGoAAAAAHOoAAAAIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAE0AaQBrAGUAIABNAHUAeQBlAG0AYgBlAAAA/";
        imgData += "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";
        imgData += "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";
        imgData += "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";
        imgData += "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";
        imgData += "AcUiv/YzPtOcPdykH8N1dZpHh7R9AhMWi6Za2Kt97yIgpb6kcn8a0aKbnKW7BJLYKKKKgZFdWsF7aS2t5Ck8EyFJIpFyrqeoI7isL/hXvg//AKFjSv8AwET/AAroqKak1sKyMzSvDei6FJI+jaVZ2DygCRreFULAdAcda06KKG29xhXO/wDCvfB//QsaV/4CJ/hXRUUJtbAY+neEfDukXi3elaJYWdwoIEsFuqMAeoyBWxRRQ23uAEBlIYZB4IPeuP1X4UeCtYuDPd6DAkpJJa2Zock9chCAfyrsKKak47MTSe5w1p8GvAlncCZNDWVl6CaeR1/75LYP412VnZWunWiWthbQ2tvGMJFCgRV+gHFT0USlKW7BJLYyNS8JeHtZvDd6tolheXBUKZZ7dXYgdBkiqn/CvfB//QsaV/4CJ/hXRUUc0l1CyEACqAvAAwKydS8J+H9ZvPtWraLY3txtC+bPbq7YHQZIrXopJtbDOd/4V74P/wChY0r/AMBE/wAK6BEWONUjUKigBVA4A9KdRQ23uFgooopAFFFFAHln7Qd4bf4cQwL/AMvV/HG30Cu381FfM9fRX7RzkeEdJT+E3xJ+ojb/ABr51r1sL/DOap8QV9R/AjTksvhdbXCrh764lnYnvhvLH6IK+XK+wPhhGIvhfoCrnBtFbn1JJP8AOpxj9xIdLc6uiiivLOgK+Z/2hP8AkpEH/YOi/wDQ5K+mK+Z/2hP+SkQf9g6L/wBDkrqwv8QzqfCeWV9h/DT/AJJj4f8A+vJP5V8eV9h/DT/kmPh//ryT+VdGM+FGdLc6iiiivNOgKy/EuvW3hnw3faxekCO1iLhScb26Ko9ycD8a1K+avjZ8RE8SaoNB0ebdptjITLIp+W4lHHHqq8gepyfQ1tRpupKxMpcqueX3t5NqF/cXt02+e4laWRv7zMck/mahorT8O6De+JtftNI0xN89y+3PZF7sfYDJr2dEjk3PYv2dfDbBtS8SXEZCkfZLZj35DOR+SjP1r3as3w9odp4a8P2ekaeuILWMIDjBY9Sx9ySSfrWlXiVZ883I64qysFFFFZlBRRRQAUVyetfE/wAIeHdYn0vWNX+z3sG3zIvs0z7dyhhyqEHgg9aof8Lq8Af9B/8A8k7j/wCIrRU5tXSYuZdzu6KZFKk8KSxHckihlOMZB5FPrMYUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAeP8A7RsefB2lSZ+7f7cfWNv8K+dK+kf2i0B+H+nv3GqIB+MUv+FfN1ethf4Ry1PiCvrT4O3n234T6M38UaSRMM5xtkYD9AK+S6+h/wBnTWhceGtT0d3zJaXAnRT/AHHGOPoyn/vqli43p37DpP3j2Siiquo6pY6RZtd6rdw2dupAMs7hFBPQZNeUdJar5n/aE/5KRB/2Dov/AEOSvdv+FheD/wDoZ9K/8C0/xr5++OWrafrPj6C60i+t76D7BGplt5RIoYO/GR35HHvXZhYtVNUZVGuU83r7D+Gn/JMfD/8A15J/KvjyvqTwP468LaN8NdEj1LX9Phlhs1WSHz1aRCB0KDLA+2K3xabirEUtz0eo554rW3ee5lSKKNSzyOwVVA6kk9K8l8Q/tC6FZI0fh6yuNTmxxJIPJiH5/MfpgfWvGvFvxF8R+M3K6telbXdlbOAbIl/D+I+5Jrmp4act9DSVRI9C+KfxnGoxT6F4QlItWBjub4DBlHQqnov+137ccnxWir2j6NqGv6pFp+j2sl1dSn5Y0HQepPQD3PFelCEaUbI523Jla0tLi/vIrWyhee4mcJHHGuWZj0AFfU3wq+G8XgfRzc3yrJrN2o8+QciJeojU/wAz3PsBTPhn8KrPwRbrfX5S71qRMPKBlIAeqp/Vu/sK9Drz8RiOf3Y7G8IW1YUVDdXcNlCstzII0aRIgSerO4RR+LMB+NTVxmoUUUUAFFFFAHyf8av+Sv61/wBsP/SeOuEru/jV/wAlf1r/ALYf+k8dcJXuUv4cfRHHL4mfcGlf8gay/wCveP8A9BFW6qaV/wAgay/694//AEEVbrwzsCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigDzD9oCNX+GYZlBKX0TKT2OGH8ia+Y6+nvj9/yTE/8AX7F/7NXzDXq4T+Gc1X4grrvhj4t/4Q7xxa307FbKb/R7v2jYj5vwIB/A1yNFdMoqSszNOzufdSOsiK6MGVhlWByCPWvOvjt/ySq7/wCviH/0MVynwU+J8bW8HhTxBMEkTCafcOeGHaInsR/D69Owz6J8TPDF94v8ET6RpTQpcSSxuDOxVcK2TyAa8jkdKqlLudV+aOh8g0V6n/wz34w/5+NK/wDAh/8A4iuH8WeFNQ8Ga5/ZWrPA9x5Sy5gcsuDnHJA9K9WNSEnaLOZxa3MSiivRvB/wW1rxfoNrrMGoWFtZXW/ZvLtINrlDlQuOqn+L0qpTjBXkJJvY85pURpHVI1LMxwqqMkn0r6D0j9nHS4WD63rd1d4OdltGsK/Qk7ifwxXo/h7wL4a8LAHRNJt4JQMeew3yn/gbZP61yyxcF8OpoqTe58/+Dfgj4h8RMlzq6No1gcEtOv75x/sp1H1bH0NfQfhXwbovg3Tvsmh2ojLAebO/zSTEd2b+nQdhW7RXDUrTqb7G0YKIUUV598U/iZb+CdLNnYOk2tXKHyY8g+QD/wAtGH8h3+gNZxi5uyKbSV2c/wDEbxsl18TPC/hTT5dyW+r2s16yngv5q7U/DOT7kelew18a+DZ5bn4l6BPcSNLLLq9u8kjnLMxmUkk9yTX2VXRiKap8sURCXNdhRRRXKaBRRRQB8n/Gr/kr+tf9sP8A0njrhK7v41f8lf1r/th/6Tx1wle5S/hx9EccviZ9waV/yBrL/r3j/wDQRXL/ABZ1i/0L4b3+oaRcva3cTxBJUxkZkUHr7E11Glf8gay/694//QRXFfG//kkup/8AXSD/ANGrXj09aiT7nVL4WeCf8LX8cf8AQxXX/fKf4V614Q+KiaP8KRrfi6+kv76S7ligiGPMmwF4HYAZ5Pb3OAfnWr2k6XqHiDVbXStMie4uZm2RR54Hc/QdSTXq1KMJLaxzxnJM63xL8YfF3iKd/L1CTS7U/dt7FjHge7j5j7849q5ceJteD7hreohs5yLuTP8AOvbNG/ZysBZo3iDWbl7lhlksgqIntlgSfrgVx/xK+Dk/gzT/AO19Ju3vtNVgswlUCSDJwCccMCeM8YJHFRCpRvyxG4z3ZV8KfGvxR4fuo01K6bWLEEB4ro5kA9Vk65+uRX0n4d1+x8T6DbatpUm+3uFyAfvIehVh2IPFfE9e6/s4atKTrWju5MSiO5iX+6eVb8/k/Ks8TRjy86HTk72Z7tXB/Ej4o2HgOBbaKMXurTLujtt2FRf7znsPQdTjt1ru3cIjO3RRk18T+Itan8ReJL/V7tmMl3M0mCc7V/hX6AYH4VzYekqktdkaVJcq0N/Wvix4z1yRzNrc9pEx4hsj5KqPTK/MR9SawT4l11mJbWtRJJySbt+f1re+GfgaPx54mewuL37JbwQmeUpgyOMgYUH3I57V7hB8BfBMUKpJBezsBy8l0QT/AN8gD9K7Z1KVJ8tjJRlLU+erLxt4o0+VXtPEOpxlTnH2pyp+qk4P4ivSfBfx+1K0uorTxki3loxCm8ijCyxe5UcMPoAfr0pfiN8D4dA0OfWvDFzcTQ2qmS4tbghmVO7KwA4A5IPbvXkVlpt9qUhj06yuLt16rBEzkfgBTtSrRuL3oM+3ba5hvLWK5tZVmgmQPHIhyGUjIINS15l8D4vEWn+FbjS/Eem3VnFbyB7NrldpKPksm08jBGef71em15c48smjpTurnzV8RfiL4t0j4iaxYabrdxb2sEwWOJQuFG0HuPeszw18TvGd74s0i1utfuZIJ76GORCq4ZS4BHT0NZnxX/5Krr3/AF8D/wBAWsfwh/yPGhf9hG3/APRi16sacPZp26HM5PmPtOiiivHOo8G+NPjjxJ4c8dQ2WiatNZ27WMchjQLgsWcE8j2Fee/8LX8cf9DFdf8AfKf4V0f7Qn/JSIP+wdF/6HJXllevRpwdNNo5ZyfMz7i06RpdLtZJGLO8KMxPclRXK/FnWL/Qvhvf6hpFy9rdxPEElTGRmRQevsTXUaV/yBrL/r3j/wDQRXFfG/8A5JLqf/XSD/0ateZTV6iXmdEvhZ4J/wALX8cf9DFdf98p/hXo+k/F+80T4SpqGp3P9pa7d3UsVqs2OFAHzsBj5Rnp3PHqR4RUttbT311Da2sbzTzOI4o0GSzE8AD6mvWnRhJbHMpyRs6n448T6veNc32u3zyN2SdkVfYKuAPwFdZ8LvGfjKfxtpmkWesT3MFzMBLDeMZlEYGXIzkrhQSMEc1Pb/s++MZrNZnm0uB2XJgkuH3j2O1Cufxrsfgp8OtV8NeItV1HxHYtbTQxi3ttxDB9xyzKRweAoz7kVlUqUuR2sVGMr6nsV7e22nWM15fTJBbwIXkkc4CqOpr558ZfHzWL+7ktvCQXTrJThbh0DTSj15yFHtjPvXR/tEa5fRaZY6JaxTC1m/0i7lCHYcHCKW6dcnHstfP1ZYahFx55FVJtOyNq68ZeJb2QyXXiDU5WJzzdvgfQZwPwqBfE2vIwZNb1FWHQi7kGP1r1rwd+z+NS0eG/8UahcWr3CB0tLZQGjB5G5mB5x2xx61r6n+zjpL2r/wBja1exXGMp9rCSIT6HaFI+v6Vs69FOxPJPc8u0T4s+M9DmRotamvIlPMN8fOVh6En5h+BFfQXw5+Jdh4+sZFEX2PU7YAz2pbIIP8aHuv6g/gT8pajYXGl6nc2F6nl3FrK0Uq+jKcH+VdV8JdTfS/ijozrJsWeb7M4zwwkBUD8yPxAorUYSg5JahCbTsz65ryr46eJ9Z8M6XpEug6hJZPNNIshjA+YBRjqK9VrxX9pH/kC6F/18S/8AoIrz6CTqJM2n8LPLv+Fr+OP+hiuv++U/wr2TWvjDb+FfAuibiNT8QXem28zxscKheJSXkI9Sc7RyfYc18110XhHwhq/jvXBY6aM7FBnuZSdkCDgZP0GAB6egJHpVKNN6vRIwjKXQs658TfF2vzs93rdzDGScQWjmGNR6YXGfxyayofFfiG3kEkGu6lG46Mt3ID/Ovc7b9nHQltAt5rOoyXG3l4giJn/dIJx+NeUfEX4dXvgDVIo5Jftdhc5NvchducdVYdmGR9fzAVOpRk+WISjNas67wN8eNVsLyKz8Xt9vsXYKboKBLD7nHDAfn7npX0RDNHcQRzQOskUih0dTkMCMgg+lfC9fUvwL1iTVfhlBFM5d9PuHtcsedow6/gA4H4Vz4qjGK54mlOTejPRqx/E/inSvCGjPqWt3HlRKdqIoy8rdlUdz+g6nArYJABJOAOpNfIvxP8aS+NPGE86SE6fas0NkmeNgPL/";
        imgData += "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";
        imgData += "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";

        doc.addImage(imgData, 'JPEG', 10, 10, 45, 15);

        doc.text("CERTIFICATE OF MOTOR INSURANCE", 46, 30);
        doc.setFontSize(8);
        x = x + 10;
        y = y + 40;
        
        doc.text("Cover Type in Words:", 115, y, );
        doc.text(this.fullQuote.vehicleDetails.cover_type.text, 150, y, );
        y = y + 4;
        doc.text("CERTIFICATE NO:", x, y, );
        doc.text(String(this.quotation_id), x+30, y, );
        doc.text("From:", 115, y, );
        doc.text(this.custom.start_date, 150, y, );
        y = y + 4;
        doc.text("POLICY NO:", x, y, );
        doc.text(String(this.fullQuote.policy_number), x+30, y, );
        doc.text("Expiry Date:", 115, y, );
        doc.text(this.fullQuote.end_date, 150, y, );
        y = y + 4;
        doc.text("CLIENT NAME:", x, y, );
        doc.text(first_name + ' ' + last_name, x+30, y, );
        doc.text("Sum Insured:", 115, y, );
        if (this.fullQuote.vehicleDetails.cover_type.value == 'COMP'){
          doc.text(this.fullQuote.currency.text + ' ' + String(this.fullQuote.estimated_value), 150, y, );
        }
        y = y + 4;
        doc.text("INSURED:", x, y, );
        doc.text(first_name + ' ' + last_name, x+30, y, );
        y = y + 4;
        doc.text("ADDRESS:", x, y, );
        doc.text(this.user.data.residential_address, x+30, y, );
        y = y + 4;
        doc.text("CELL:", x, y, );
        doc.text(this.user.data.phone_number, x+30, y, );
        y = y + 4;
        doc.text("EMAIL:", x, y, );
        doc.text(email_address, x+30, y, );
        doc.setFontSize(14);
        y = y + 10;
        doc.text("Particulars of Vehicle", x, y, );
        // draw table
        doc.setLineWidth(0.1); 
        y = y + 5;
        doc.line(x, y, 200, y);
        doc.line(x, y, x, y+16);
        doc.line(x, y+8, x+190, y+8);
        doc.line(x, y+16, x+190, y+16);
        doc.line(200, y, x+190, y+16);
        doc.setFontSize(8);
        doc.setFontStyle('bold');
        y = y + 4;
        doc.text("Reg Mark", x+2, y, );
        doc.line(x+20, y-4, x+20, y+12);
        doc.text("Make and Model", x+22, y, );
        doc.line(x+55, y-4, x+55, y+12);
        doc.text("Engine No", x+57, y, );
        doc.line(x+90, y-4, x+90, y+12);
        doc.text("Chassis No", x+92, y, );
        doc.line(x+125, y-4, x+125, y+12);
        doc.text("Year of Manf", x+127, y, );
        doc.line(x+160, y-4, x+160, y+12);
        doc.text("Color", x+162, y, );
        doc.setFontStyle('normal');
        y = y + 8;
        doc.text(this.fullQuote.vehicleDetails.vehicle_reg, x+2, y, );
        doc.text(this.fullQuote.vehicleDetails.vehicle_make + ' - ' + this.fullQuote.vehicleDetails.vehicle_model, x+22, y, );
        doc.text(this.fullQuote.vehicleDetails.engine_number, x+57, y, );
        doc.text(this.fullQuote.vehicleDetails.chassis_number, x+92, y, );
        doc.text(this.fullQuote.vehicleDetails.year_of_manf, x+129, y, );
        doc.text(this.fullQuote.vehicleDetails.vehicle_color, x+162, y, );

        
        doc.setFontSize(14);
        y = y + 15;
        doc.text("Third Party Limits of Liability", x, y, );
        doc.setFontSize(8);
        y = y + 6;
        doc.text("Third Party Property Damage", x, y, );
        y = y + 4;
        doc.text("Third Party Injury and Death", x, y, );
        y = y + 4;
        doc.text("Combined Third Party Limits of Liability:           ZMW 200,000.00", x, y, );
        
        y = y + 16;
        doc.text("We hereby certify that the policy to  which this document relates is issued in", x, y, );
        y = y + 4;
        doc.text("accordance with the provisions of Part IXV of the Roads & Road Traffic Act", x, y, );
        y = y + 4;
        doc.text("of the republic of Zambia.", x, y, );
        y = y + 6;
        doc.text("Claims Third Party Recovery - In the event of a collision, when the driver of", x, y, );
        y = y + 4;
        doc.text("the Third Party vehicle  is  found  to  be at fault, the insured will take all", x, y, );
        y = y + 4;
        doc.text("reasonable steps to bind the Driver of the 3rd Party vehicle Owner and its", x, y, );
        y = y + 4;
        doc.text("Insurance Company to meet the cost of repairs and other claims before", x, y, );
        y = y + 4;
        doc.text("repairs to theInsured's vehicle are authorized.", x, y, );
        // render a circle (y = 150)
        doc.circle(152.5, 160.25, 47,);
        doc.setFontSize(10);
        doc.text("Vehicle Reg No.:", 112, 150, );
        doc.text(this.fullQuote.vehicleDetails.vehicle_reg, 140, 150, );
        doc.text("Make:", 111, 155, );
        doc.text(this.fullQuote.vehicleDetails.vehicle_make, 140, 155, );
        doc.text("Type:", 165, 155, );
        doc.text(this.fullQuote.vehicleDetails.vehicle_model, 180, 155, );
        doc.text("Color:", 110, 160, );
        doc.text(this.fullQuote.vehicleDetails.vehicle_color, 140, 160, );
        doc.text("Engine No.:", 111, 165, );
        doc.text(this.fullQuote.vehicleDetails.engine_number, 140, 165, );
        doc.text("Chassis No.:", 112, 170, );
        doc.text(this.fullQuote.vehicleDetails.chassis_number, 140, 170, );
        doc.text("Date of Issue:", 113, 175, );
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); 
        var yyyy = today.getFullYear();

        today = mm + '/' + dd + '/' + yyyy;
        doc.text(today, 140, 175, );
        doc.text("Time of Issue:", 115, 180, );
  
        doc.text("Expiry Date:", 118, 185, );
        doc.text(this.fullQuote.end_date, 140, 185, );
        doc.text("Quarter:", 165, 185, );
        doc.text("4", 180, 185, );
        doc.text("Town:", 123, 190, );
        doc.text("Lusaka", 140, 190, );
        doc.text("Zambia", 165, 190, );
        doc.setFontSize(8);
        doc.setFontStyle('bold');
        // Excess policy
        y = y + 50;
        doc.text("Policy Excess", x, y, );
        doc.setFontStyle('normal');
        doc.text("- As per Policy Clauses", x+20, y, );
        y = y + 6;
        doc.setFontStyle('bold');
        doc.text("Notification Clause:", x, y, );
        doc.setFontStyle('normal');
        doc.text("On happening of an event giving rise to a claim, notification must be done within 48hrs for accidental damage and 24hrs for theft", x+27, y, );
        y = y + 4;
        doc.text("from the time of happening of an event.", x, y, );
        y = y + 10;
        doc.text("Date:", x, y, );
        doc.text("Time:", x+50, y, );
        doc.text("Signature:", x+100, y, );
        y = y + 4;
        
        doc.setFontStyle('bold');
        y = y + 10;
        doc.text("NOTE: THIS INSURANCE CEASES ON THE SALE OR CHANGE OF OWNERSHIP OF THE STATED VEHICLE. COVER RESTRICTED WITHIN", x, y, );
        y = y + 4;
        doc.text("ZAMBIA ONLY.", x, y, );
        doc.setTextColor(150);
        doc.setFontStyle('bold');
        
        doc.setFontSize(26);
        doc.text(85, 19, 'Copy');
        doc.text(150, doc.internal.pageSize.height - 160, 'Copy');
        doc.text(150, doc.internal.pageSize.height - 230, 'Copy');
        
        doc.setFontSize(12);
        doc.text(86, 24, 'of Original');
        doc.text(151, doc.internal.pageSize.height - 155, 'of Original');
        doc.text(151, doc.internal.pageSize.height - 225, 'of Original');
        doc.output('dataurlnewwindow'); 
      },
      downloadQuotation() {   
        var first_name = '';
        var last_name = '';

        if (this.user.loggedIn){
          first_name = this.user.data.first_name;
          last_name = this.user.data.last_name;
        }else{
          first_name = this.custom.first_name;
          last_name = this.custom.last_name;
        }

        var doc = new jsPDF();

        var imgData = "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";
        
        doc.addImage(imgData, 'JPEG', 15, 10, 60, 26);

        var x=15;
        var y=40;

        doc.setFillColor(176,223,229);
        doc.rect(x, y, 180, 40, 'DF');

        doc.addFont('Book Antiqua');
        doc.setFont('Book Antiqua');
        doc.setFontSize(12);
        
        x = x + 2;
        y = y + 5;
        doc.text("We  are  pleased to render our  terms  and  conditions  for  your favourable consideration  as contained", x, y,);
        y = y + 5;
        doc.text("herein.", x, y,);
        y = y + 8;
        doc.text("Also note that PICZ is currently the only primary insurance company in Zambia with a credit rating. We ", x, y,);
        y = y + 5;
        doc.text("are rated A+ by Global Credit Rating-(GCR). Details on the  same can be  availed to you on request but ", x, y,);
        y = y + 5;
        doc.text("suffice to say that the rating evidences our ability to pay claims timely. ", x, y,);

        x = x - 1;
        y = y + 30;
        doc.setTextColor(212,175,55);

        doc.text(first_name + " " + last_name, x, y,)

        doc.setTextColor(0,0,0);
        doc.setFontStyle('bold');

        y = y + 8;
        doc.text("Quotation", x, y,);

        //var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

        y = y + 8;
        doc.text("Period of Cover", x, y,);
        doc.setFontStyle('normal');
        doc.text(":      " + this.fullQuote.start_date + " to " + this.fullQuote.end_date, x+50, y,);
        doc.setFontStyle('bold');
        y = y + 8;
        doc.text("Insurer", x, y,);
        doc.setFontStyle('normal');
        doc.text(":      Professional Insurance Corporation Zambia Plc", x+50, y,);
        doc.setFontStyle('bold');
        y = y + 8;
        doc.text("Branch/Unit", x, y,);
        doc.setFontStyle('normal');
        doc.text(":      Digital Channels", x+50, y,);
        doc.setFontStyle('bold');
        y = y + 8;
        doc.text("Quotation prepared on", x, y,);
        doc.setFontStyle('normal');
        doc.text(":      " + this.formatDate(new Date().toISOString().substr(0, 10)), x+50, y,);
        doc.setFontStyle('bold');
        y = y + 8;
        doc.text("Validity of Quotation", x, y,);
        doc.setFontStyle('normal');
        doc.text(":      30 days", x+50, y,);

        y = y + 20;
        doc.text("We hope that you will find our quotation favourable and look forward to your instructions to place cover.", x, y,);
        
        y = y + 10;

        doc.setFillColor(176,223,229);
        doc.rect(x+40, y, 100, 5, 'DF');

        y = y + 4;
        doc.setTextColor(0,0,128);
        doc.text((this.fullQuote.vehicleDetails.vehicle_type.text).toUpperCase() + " MOTOR "+ (this.fullQuote.vehicleDetails.cover_type.text).toUpperCase() +" POLICY", x+41, y,);

        y = y + 10;
        doc.text("COVER", x, y,);
        if (this.fullQuote.vehicleDetails.cover_type.value == 'COMP'){
          y = y + 8;
          doc.setTextColor(0,0,0);
          doc.text("Accidental loss or damage including Non Political Riot and Strike to insured vehicles and ", x,y,);
          y = y + 5;
          doc.text("indemnity against third party legal liability.",x,y,);
          y = y + 12;
        }else{
          y = y + 8;
          doc.setTextColor(0,0,0);
          doc.text("All sums including claimant’s costs and expenses which the insured shall become legally liable ", x,y,);
          y = y + 5;
          doc.text("to pay in respect of death of or bodily injury to any person or damage to property where such .",x,y,);
          y = y + 5;
          doc.text("death or injury or damage arises out of an accident caused by or in connection with the use .",x,y,);
          y = y + 5;
          doc.text("of the motor vehicle .",x,y,);

          y = y + 12;
        }
        doc.setTextColor(0,0,128);
        doc.text("INTEREST", x, y,);

        var sum_insured = 'N/A';
        if (this.fullQuote.vehicleDetails.cover_type.value == 'COMP'){
          sum_insured = (parseFloat(this.fullQuote.estimated_value)).toFixed(2);
        }

        y = y + 5;
        doc.setFillColor(211,211,211);
        doc.rect(x, y, 180, 7, 'DF');
        doc.setTextColor(0,0,0);
        doc.text("Make/Model", x+1,y+4,);
        doc.text("Registration Mark", x+61,y+4,);
        doc.text("Sum Insured (" + this.fullQuote.currency.text + ")", x+121,y+4,);
        y = y + 7;
        doc.rect(x, y, 180, 7);
        doc.line(x+60, y-7, x+60, y+7);
        doc.line(x+120, y-7, x+120, y+7);
        doc.text(this.fullQuote.vehicleDetails.vehicle_make + " " + this.fullQuote.vehicleDetails.vehicle_model, x+1,y+4,);
        doc.text(this.fullQuote.vehicleDetails.vehicle_reg, x+61,y+4,);
        doc.text(sum_insured, x+121,y+4,);
        y = y + 20;
        doc.setTextColor(0,0,128);
        doc.text("COMBINED THIRD PARTY LIABILITY LIMIT", x, y,);
        doc.setTextColor(0,0,0);
        doc.text("K200,000.00", x+100, y,);
        y = y + 8;
        doc.setTextColor(0,0,0);
        doc.text("Bodily injury/death", x, y,);
        y = y + 5;
        doc.text("Property damage", x, y,);
        y = y + 5;
        doc.text("Passenger Liability (authorised and unauthorised)", x, y,);

        doc.addPage();
        y = 30;
        doc.setTextColor(0,0,128);

        if (this.fullQuote.vehicleDetails.cover_type.value == 'COMP'){
          doc.text("ADDITIONAL BENEFITS", x, y,);
          y = y + 8;
          doc.setTextColor(0,0,0);
          doc.text("-    Personal Effects - K2,000.00", x+10, y,);
          y = y + 5;
          doc.text("-    Medical Expenses - K5,000.00", x+10, y,);
          y = y + 5;
          doc.text("-    Loss of Keys – K1,000.00 ", x+10, y,);
          y = y + 5;
          doc.text("-    Undeclared Radios/Equipment – K1, 000", x+10, y,);
          y = y + 5;
          doc.text("-    Towing Charges K1,000.00 ", x+10, y,);
          y = y + 5;
          doc.text("-    Authorised/Unauthorised passengers – Included in Third Party Liability", x+10, y,);

          y = y + 10;
          doc.setTextColor(0,0,128);
          doc.text("EXCESS", x, y,);
          y = y + 8;
          doc.setTextColor(0,0,0);
          doc.text("The insured shall be responsible for the first 10% of each and every claim/loss subject to ", x, y,);
          y = y + 5;
          doc.text("retained minimum liability of ZMW500.00", x, y,);
          y = y + 8;
          doc.text("Excess applicable on young/inexperienced drivers shall be as hereunder:", x, y,);
          y = y + 5;
          doc.text("i.    Any person who is below the age of 21 years of age – 10% minimum K1, 000.00", x+10, y,);
          y = y + 5;
          doc.text("ii.   Any person over 70 years of age 10% minimum K1,000.00", x+10, y,);
          y = y + 5;
          doc.text("iii.  Any person who has not held a full driver’s licence for a minimum period of 24 ", x+10, y,);
          y = y + 5;
          doc.text("      months 10% minimum K1,200.00", x+10, y,);
          y = y + 5;
          doc.text("iv.   Any person who has been convicted and has had a licence endorsed as a result of ", x+10, y,);
          y = y + 5;
          doc.text("      the following during the previous three years:", x+10, y,);
          y = y + 5;
          doc.text("      (a)   careless or reckless driving - 10% minimum K1,200.00", x+10, y,);
          y = y + 5;
          doc.text("      (b)   any other endorsement - 10% minimum K1,000.00", x+10, y,);

          y = y + 10;
          doc.setTextColor(0,0,128);
          doc.text("PREMIUM CALCULATION", x, y,);
          y = y + 8;
          doc.text("Rate ", x, y,);
          doc.text(this.fullQuote.rate + " %", x+70, y,);
          y = y + 5;
          doc.text("Basic Premium ", x, y,);
          doc.text(this.fullQuote.currency.text + " " + this.fullQuote.base, x+70, y,);
          y = y + 5;
          doc.text("Discount ", x, y,);
          doc.text(this.fullQuote.currency.text + " 0.00", x+70, y,);
          y = y + 5;
          doc.text("Net Premium ", x, y,);
          doc.text(this.fullQuote.currency.text + " " + this.fullQuote.premium, x+70, y,);
          y = y + 5;
          doc.text("Levy @ 3% ", x, y,);
          doc.text(this.fullQuote.currency.text + " " + this.fullQuote.levy, x+70, y,);
          y = y + 5;
          doc.text("Total Premium  Due", x, y,);
          doc.text(this.fullQuote.currency.text + " " + this.fullQuote.premium, x+70, y,);
        }else{              
          doc.text("EXCESS", x, y,);
          y = y + 8;
          doc.setTextColor(0,0,0);
          doc.text("10% minimum K500 each claim for third party property damage  ", x, y,);
          y = y + 5;
          doc.setFontType("italic");
          doc.text("Addition to own damage excess ", x, y,);
          y = y + 5;
          doc.setFontType("normal");
          doc.text("10% minimum K500 each claim for young drivers (less than 25 years old)", x, y,);
          y = y + 5;
          doc.text("10% minimum K500 each claim for inexperienced drivers (holder of a valid driver’s license for ", x, y,);
          y = y + 5;
          doc.text("less than 2 years) ", x, y,);
          
          y = y + 10;
          doc.setTextColor(0,0,128);
          doc.text("PREMIUM CALCULATION", x, y,);
          y = y + 8;
          doc.text(this.fullQuote.currency.text + " " + this.fullQuote.base + " x 1", x, y,);
          doc.text(this.fullQuote.currency.text + " " + this.fullQuote.base, x+70, y,);
          y = y + 5;
          doc.text("Plus 3% Levy ", x, y,);
          doc.text(this.fullQuote.currency.text + " " + this.fullQuote.levy, x+70, y,);
          y = y + 5;
          doc.text("Total Premium  Due", x, y,);
          doc.text(this.fullQuote.currency.text + " " + this.fullQuote.premium, x+70, y,);
        }

        y = y + 10;
        doc.setTextColor(0,0,0);
        doc.text("SALIENT CONDITIONS", x, y,);
        y = y + 8;
        doc.setFontStyle('bold');
        doc.text("Drivers Clause ", x, y,);
        doc.setFontStyle('normal');
        y = y + 8;
        doc.text("Unless otherwise agreed, driving shall be restricted to persons aged at least 22 years who have ", x, y,);
        y = y + 5;
        doc.text("held a valid licence for at least 2 years.", x, y,);
        y = y + 10;
        doc.setFontStyle('bold');
        doc.text("Replacement Parts ", x, y,);
        doc.setFontStyle('normal');
        y = y + 8;
        doc.text("It is hereby understood and agreed notwithstanding anything herein contained to the contrary  ", x, y,);
        y = y + 5;
        doc.text("that in the event of loss or damage to the motor vehicle or its accessories or spare parts ", x, y,);
        y = y + 5;
        doc.text("necessitating the supply of a part not obtainable from the stocks held in the country in which", x, y,);
        y = y + 5;
        doc.text("the motor vehicle is held for repair in the event of the company exercising the option under ", x, y,);
        y = y + 5;
        doc.text("sub-section A.2 to pay in the cash amount of the loss or damage the liability of the company  ", x, y,);
        y = y + 5;
        doc.text("in respect of any such part shall be limited to: ", x, y,);
        doc.addPage();
        y = 30;
        doc.text("(a)  (i) The price quoted in the latest catalogue or price list issued by the manufacturer ", x+10, y,);
        y = y + 5;
        doc.text("     or his agents for the country in which the motor vehicle is held for repair.", x+10, y,);
        y = y + 5;
        doc.text("     (ii)If no such catalogue or price list exists the price last obtaining at the manufacturer’s ", x+10, y,);
        y = y + 5;
        doc.text("     works plus the reasonable cost of transport or otherwise than by air to the country in ", x+10, y,);
        y = y + 5;
        doc.text("     which the motor vehicle is held for repair and the amount the relative import duty, and", x+10, y,);
        y = y + 5;
        doc.text("(b)  The reasonable cost of fitting such part.", x+10, y,);
        y = y + 10;
        doc.setFontStyle('bold');
        doc.text("24 Hours Notification Warranty ", x, y,);
        doc.setFontStyle('normal');
        y = y + 8;
        doc.text("It is a condition precedent to liability under this motor insurance that in all cases of theft of the  ", x, y,);
        y = y + 5;
        doc.text("insured vehicle(s) the insured or his authorized user, driver or agent shall immediately notify  ", x, y,);
        y = y + 5;
        doc.text("the Police and the Insurer by whatever fastest means possible and in any event not later than 24 ", x, y,);
        y = y + 5;
        doc.text("hours, except weekends or holidays to the insurer.  This warranty hereby overrides general ", x, y,);
        y = y + 5;
        doc.text("condition 6 (a) (i) contained in the general section of the multi-peril policy. ", x, y,);

        doc.save('Quotation.pdf'); 
        doc.output('dataurlnewwindow');
      },
      getPhoneNumber(payload){
        this.user.data.phone_number = payload.formattedNumber;
      },
      uploadPhotos(){
        // TO DO
      }
    },
    computed: {
      ...mapGetters({
        user: "user",
        fullQuote: "fullQuote",
        components: "components",
        policies: "policies"
      }),
      reference() {
        let text = "";
        let possible =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (let i = 0; i < 10; i++)
          text += possible.charAt(Math.floor(Math.random() * possible.length));
        return text;
      },
      computedDateFormatted () {
        return this.formatDate(this.date)
      },
    },
    created(){
      var options = {
        enableHighAccuracy: false,
        timeout: Infinity, 
        maximumAge: 0 
    
      }
      this.$getLocation(options)
      .then(coordinates => {
        this.custom.coordinates.latitude = coordinates.lat;
        this.custom.coordinates.longitude = coordinates.lng;
      });
      if (this.user.loggedIn){
        this.custom.phone_number = (this.user.data.phone_number).substr(4,13);
      }
      // get vehicle makes
      /*var MAKES_URL = `https://vpic.nhtsa.dot.gov/api/vehicles/getallmakes?format=json`;

      axios
        .get(MAKES_URL)
        .then(response => {
          this.makes = response.data;
          console.log(this.makes);
        })
        .catch(error => {
          console.log('Error',error);
        });*/
    }
  }
</script>
<style scoped>
.centered-input input {
  text-align: center
}
</style>
